/* ============================================
   FLAVOR THEME — Product Form
   Variant selection, gallery, sticky ATC
   ============================================ */

(function () {
  'use strict';

  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  var productJson = section.querySelector('[data-product-json]');
  if (!productJson) return;

  var product;
  try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

  var variantSelectors = section.querySelectorAll('[data-variant-option]');
  var form = section.querySelector('form[data-product-form]');
  var variantIdInput = form ? form.querySelector('input[name="id"]') : null;

  /* --- Variant selection --- */
  function getSelectedOptions() {
    var options = [];
    variantSelectors.forEach(function (group) {
      var selected = group.querySelector('input:checked') || group.querySelector('select');
      if (selected) {
        options.push(selected.value);
      }
    });
    return options;
  }

  function findVariant(options) {
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === options[i];
      });
    });
  }

  function onVariantChange() {
    var options = getSelectedOptions();
    var variant = findVariant(options);
    if (!variant) return;

    /* Update hidden input */
    if (variantIdInput) variantIdInput.value = variant.id;

    /* Update URL */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    /* Update price */
    var priceEl = section.querySelector('[data-product-price]');
    var comparePriceEl = section.querySelector('[data-product-compare-price]');
    if (priceEl) priceEl.textContent = Flavor.formatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = Flavor.formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    /* Update add to cart button */
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addBtnText = section.querySelector('[data-add-to-cart-text]');
    if (addBtn && addBtnText) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtnText.textContent = Flavor.strings.addToCart;
      } else {
        addBtn.disabled = true;
        addBtnText.textContent = Flavor.strings.soldOut;
      }
    }

    /* Update sticky ATC */
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyTitle = document.querySelector('[data-sticky-variant]');
    if (stickyPrice) stickyPrice.textContent = Flavor.formatMoney(variant.price);
    if (stickyTitle) stickyTitle.textContent = variant.title !== 'Default Title' ? variant.title : '';

    /* Switch gallery image if variant has featured image */
    if (variant.featured_image) {
      var gallery = section.querySelector('[data-product-gallery]');
      if (gallery) {
        var targetImg = gallery.querySelector('img[data-image-id="' + variant.featured_image.id + '"]');
        if (targetImg) {
          targetImg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  }

  /* Listen for variant option changes */
  variantSelectors.forEach(function (group) {
    group.addEventListener('change', onVariantChange);
  });

  /* --- Add to cart --- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.disabled = true;

      var formData = new FormData(form);
      var body = {};
      formData.forEach(function (v, k) { body[k] = v; });

      fetch(Flavor.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) {
          alert(data.description);
        } else {
          Flavor.updateCartDrawer();
          Flavor.openCartDrawer();
        }
      })
      .catch(function (err) { console.error('Add to cart error:', err); })
      .finally(function () {
        if (addBtn) addBtn.disabled = false;
      });
    });
  }

  /* --- Sticky Add to Cart visibility --- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainATC = section.querySelector('[data-add-to-cart]');
  if (stickyBar && mainATC) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('flavor-sticky-atc--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainATC);
  }

  /* --- Image zoom on hover --- */
  var zoomContainers = section.querySelectorAll('[data-zoom]');
  zoomContainers.forEach(function (container) {
    container.addEventListener('mousemove', function (e) {
      var rect = container.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      var img = container.querySelector('img');
      if (img) img.style.transformOrigin = x + '% ' + y + '%';
    });
    container.addEventListener('mouseenter', function () {
      var img = container.querySelector('img');
      if (img) img.style.transform = 'scale(2)';
    });
    container.addEventListener('mouseleave', function () {
      var img = container.querySelector('img');
      if (img) { img.style.transform = ''; img.style.transformOrigin = ''; }
    });
  });

  /* --- Accordion toggles --- */
  section.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var content = trigger.nextElementSibling;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !isOpen);
      content.hidden = isOpen;
    });
  });

  /* --- Quantity selector --- */
  section.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[name="quantity"]');
    wrapper.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
    wrapper.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

})();
